import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

const state = {
  records: [],
  record: {},
  meta: {},
  links: {},
  uiFlags: {
    isCreating: false,
    isFetching: false,
    isUpdating: false,
    isMerging: false,
    isDeleting: false,
    isJourneyLoading: false,
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
